import React, { useEffect, useState } from "react"
import FreestarAdSlot from "@freestar/pubfig-adslot-react-component"
import { byPassProps } from "./utils"

import { AdUnit, TitleWrapper, IconWrapper, InfoIcon, Tooltip, TooltipText } from "./styles"

const NetworkAd = ({
  className,
  dataId,
  placementName,
  articleId,
  hideTitle,
  isInlineAd = false,
  position,
  maxHeight,
  targetingOptions,
  ...props
}) => {
  const [isReady, setIsReady] = useState(false)
  const [isTTD, setIsTTD] = useState(false)
  const [isSearch, setIsSearch] = useState(false)
  const slotId = crypto.randomUUID()
  const [extraProps, setExtraProps] = useState({})

  useEffect(() => {
    const { search } = window.location
    if (search) {
      const urlParams = new URLSearchParams(search)
      setIsTTD(`${urlParams.get("utm_source") === "ttd"}`)
      const byPassObject = byPassProps[placementName]
      if (urlParams.get("utm_source") === "jungroup" && byPassObject) {
        setExtraProps({
          adUnitPath: byPassObject.adUnitPath,
          slotSize: byPassObject.slotSize,
          sizeMapping: byPassObject.sizeMapping,
        })
      }
    }
    setIsSearch(`${Boolean(document.referrer?.match(/^https:\/\/www\.(google|bing)\.com/))}`)
    setIsReady(true)
  }, [])

  if (!isReady) return null

  return (
    <AdUnit
      className={className}
      data-exp-id={dataId}
      {...props}
      isInlineAd={isInlineAd}
      maxHeight={maxHeight}
    >
      {!hideTitle && (
        <TitleWrapper>
          <h5>Advertisement</h5>
          <IconWrapper tabIndex={0}>
            <InfoIcon id="info-icon" height="19px" width="19px" />
          </IconWrapper>
          <Tooltip>
            <TooltipText>
              This ad is displayed using third party content and we do not control its accessibility
              features.
            </TooltipText>
          </Tooltip>
        </TitleWrapper>
      )}
      <div id={slotId}>
        <FreestarAdSlot
          publisher="mindbodygreen-com"
          placementName={placementName}
          targeting={{ ...targetingOptions, ttd: isTTD, search_referer: isSearch }}
          slotId={slotId}
          {...extraProps}
        />
      </div>
    </AdUnit>
  )
}

export default React.memo(NetworkAd)
